import { Tabs } from 'antd';
import { Loading } from 'components';
import GeneralHeader from 'components/common/GeneralHeader';
import LeaveProfileGeneral from 'components/tables/leave_profile_general';
import LeaveProfileTabs2 from 'components/tables/leave_profile_tabs2';
import useMember from 'hooks/useMember';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const LeaveProfileDetail = () => {
  const { getStaffLeaveProfileById, getAbsenceTypesListAll } =
    useMember();
  const location = useLocation();
  const [fetchData, setFetchData] = useState();
  const [activeTab, setActiveTab] = useState('1');
  const [absenceTypes, setAbsenceTypes] = useState([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  useEffect(() => {
    // const pathName = location.pathname;
    // const parts = pathName.split('/');
    const parametValue = location?.state?.id;
    setLoading(true);
    getStaffLeaveProfileById(parametValue)
      .then((res) => {
        if (res) {
          setFetchData(res);
          setLoading(false);
        }
      })
      .catch((err) => console.log(err));

    getAbsenceTypesListAll().then((res) => {
      setAbsenceTypes(res.data);

    });

  }, []);

  if (loading) return <Loading />;
  return (
    <div>
      <GeneralHeader
        pageTitle={location?.state?.name}
        icon="/assets/leave_profile.svg"
        child={
          <div style={{ marginTop: '100px', paddingBottom: '50px' }}>
            <Tabs
              style={{ marginTop: '100px' }}
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={(key) => { setActiveTab(key) }}
              items={[
                {
                  key: '1',
                  label: (
                    <div style={{ color: activeTab === '1' ? '#0E3063' : '#757575', fontSize: '20px', fontWeight: 600, margin: '0px 10px' }}>
                      General
                    </div>
                  ),
                  children: <LeaveProfileGeneral data={fetchData} />,
                },
                {
                  key: '2',
                  label: (
                    <div style={{ color: activeTab === '2' ? '#0E3063' : '#757575', fontSize: '20px', fontWeight: 600, margin: '0px 10px' }}>
                      Staff Leave and Absence Types
                    </div>
                  ),
                  children: (
                    <LeaveProfileTabs2
                      absenceTypes={absenceTypes}
                      data={fetchData}
                      checked={false}
                    />
                  ),
                },
              ]}
            />
          </div>
        }
      />
    </div>
  );
};

export default LeaveProfileDetail;
